import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWatch = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(5.2512 0.2496)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Icon",
			d: "M7.77734 0C8.99556 4.58027e-05 10.0684 0.801611 10.4141 1.96973L11.3281 5.06152C12.5693 5.32713 13.5 6.42958 13.5 7.75V15.75C13.5 17.0704 12.5692 18.1718 11.3281 18.4375L10.4141 21.5303C10.0684 22.6984 8.99558 23.5 7.77734 23.5H5.72266C4.50444 23.5 3.4316 22.6984 3.08594 21.5303L2.1709 18.4375C0.930339 18.1715 0 17.07 0 15.75V7.75C1.11996e-07 6.42991 0.930239 5.32748 2.1709 5.06152L3.08594 1.96973C3.43161 0.801601 4.50442 1.87187e-05 5.72266 0H7.77734ZM3.75391 18.5L4.52441 21.1045C4.68149 21.6355 5.16891 22 5.72266 22H7.77734C8.33111 22 8.8185 21.6355 8.97559 21.1045L9.74609 18.5H3.75391ZM2.75 6.5C2.05964 6.5 1.5 7.05964 1.5 7.75V15.75C1.5 16.4404 2.05964 17 2.75 17H10.75C11.4404 17 12 16.4404 12 15.75V7.75C12 7.05964 11.4404 6.5 10.75 6.5H2.75ZM7.5 11.542L9.15918 12.6211L8.34082 13.8789L6.34082 12.5791C6.12814 12.4408 6.00007 12.2039 6 11.9502V8.25H7.5V11.542ZM5.72266 1.5C5.16889 1.50002 4.6815 1.8645 4.52441 2.39551L3.75391 5H9.74609L8.97559 2.39551C8.81851 1.86451 8.33109 1.50005 7.77734 1.5H5.72266Z",
			fill: "currentColor"
		})
	})
});
export default SvgWatch;
